import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import GlobalOutlinedSvg from "@ant-design/icons-svg/es/asn/GlobalOutlined";
import AntdIcon from "../components/AntdIcon";
var GlobalOutlined = function GlobalOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GlobalOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  GlobalOutlined.displayName = 'GlobalOutlined';
}
export default /*#__PURE__*/React.forwardRef(GlobalOutlined);